import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects } from "utils";

const useCreateRating = (bookId) => {
	const queryClient = useQueryClient();
	const { accessToken } = useTokenStore();
	const history = useHistory();

	const createRating = async (payload) => {
		const instance = await InitApi({ accessToken });
		const body = deleteEmptyObjects(payload);
		const response = await instance.post("/ratings", body);
		return response;
	};

	return useMutation(createRating, {
		onSuccess: async ({ data }) => {
			await queryClient.invalidateQueries(["books", String(bookId)]);
			await queryClient.invalidateQueries(["books", Number(bookId)]);
			await queryClient.invalidateQueries(["books", bookId]);
			toast.success(data?.message || "Thanks for rating this book.");
		},
		onError: async (error) => {
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{ className: "max-w-max" }
			);

			if (error?.response?.data?.message === "Unauthenticated.") {
				reactLocalStorage.clear();
				history.push("/");
			}
		},
	});
};

export default useCreateRating;
